<template>
  <td :style="colorStyle(audit.createdBy.toString(), userSettingsStore.data.showAuditVisual)"><AuditItem :at="audit.createdAt" :by="audit.createdBy" /></td>
</template>

<script setup lang="ts">
import AuditItem from "@/components/AuditItem.vue";
import Audit from "@/models/frontend/audit";
import { colorStyle } from '@/services/colors';
import { useUserSettingsStore } from '@/stores';

const userSettingsStore = useUserSettingsStore();

defineProps({
  audit: { type: Object as () => Audit, required: true }
});
</script>
